import { ICroppedImage } from 'models/profile-picture/ICroppedImage';

export interface IUploadStatus {
    errorMessage: string;
    fileId: number;
    successful: boolean;
    url: string;
}

export const uploadProfileImage = async (image: ICroppedImage, workerId: number, token: string): Promise<IUploadStatus> => {
    const perspectiveId = (window as any).ENV.REACT_APP_PERSPECTIVE_ID ? +(window as any).ENV.REACT_APP_PERSPECTIVE_ID : 70119;

    const form = new FormData();
    form.append('file', image.blob);
    const options = {
        method: 'POST',
        body: form
    } as RequestInit;

    return fetch(`/api/v1/worker/${workerId}/perspective/${perspectiveId}/photo?token=${token}`, options)
        .then(res => {
            return res.json();
        })
        .catch(err => {
            console.log('Error creating account', err);
        });
};
